import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/sa/web-sa/header.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner banner_hire_sa"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>
                  Game App Development in <span>Saudi Arabia</span>
                </h1>
              </div>
              <p className="main_para">
                Create an impact in the vibrant world of game development in
                Saudi Arabia. We're pioneers in crafting wholesome digital
                experiences that enable you to engage the maximum audience. With
                our passion for innovation and in-depth understanding of the
                gaming industry, we bring imagination to life, covering one
                pixel at a time. From Riyadh to Jeddah, our team of expert game
                developers leverages the latest technologies and our proven
                strategies to fascinating immersive games that set trends.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Game
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
